const EventContent = (props) => {
  return (
    <div className="rspec-event-content"><p>{props.event.content}</p></div>
  );
};

export default EventContent;
